/* ============================================================
   CYR · JS de ficha (FAQ acordeón + modal guía de tamaños)
   Cargado UNA vez, idempotente, delegación de eventos.
   El modal se crea solo (singleton) → la guía puede ir en varios sitios.
   ============================================================ */
(function () {
  if (window.__cyrPdpInit) return;
  window.__cyrPdpInit = true;

  // --- FAQ: al abrir un item, cierra los demás ---
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d.classList || !d.classList.contains('cr-lux-item') || !d.open) return;
    var wrap = d.closest('.cr-lux-wrapper');
    if (!wrap) return;
    wrap.querySelectorAll('.cr-lux-item[open]').forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
  }, true);

  // --- Guía de tamaños: modal singleton creado por JS ---
  function ensureModal() {
    var m = document.getElementById('sgModal');
    if (!m) {
      m = document.createElement('div');
      m.id = 'sgModal';
      m.className = 'sg-modal';
      m.innerHTML = '<div class="sg-modal-backdrop js-close-modal"></div><div class="sg-modal-content"><button class="sg-modal-close js-close-modal" aria-label="Cerrar">&times;</button><img id="sgModalImg" src="" alt="Guía de tallas"></div>';
      document.body.appendChild(m);
    }
    return m;
  }
  function closeSg() {
    var m = document.getElementById('sgModal');
    if (m) { m.classList.remove('is-visible'); document.body.style.overflow = ''; }
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('.js-open-modal');
    if (open) {
      e.preventDefault();
      var url = open.getAttribute('data-img');
      var m = ensureModal();
      var img = document.getElementById('sgModalImg');
      if (url && img) { img.src = url; m.classList.add('is-visible'); document.body.style.overflow = 'hidden'; }
      return;
    }
    if (e.target.closest('.js-close-modal')) closeSg();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSg(); });
})();
